import { useScreenSlideIn } from '@/hooks/useScreenSlideIn';
import styles from './index.module.scss';
import figureBgImg from '@/assets/productCenter/ai/ai-screen5-figure-bg.png';
import figureImg1 from '@/assets/productCenter/ai/ai-screen5-figure1.png';
import figureImg2 from '@/assets/productCenter/ai/ai-screen5-figure2.png';
import figureImg3 from '@/assets/productCenter/ai/ai-screen5-figure3.png';
import figureImg4 from '@/assets/productCenter/ai/ai-screen5-figure4.png';
import figureImg5 from '@/assets/productCenter/ai/ai-screen5-figure5.png';
import figureTxtBg from '@/assets/productCenter/ai/ai-screen5-txt-bg.png';

const SCROLL_CONTAINER = '[data-scroll-root="aixue-ai-scroll"]';

const SCREEN5_CARDS = [
  {
    figureImg: figureImg1,
    title: '思维导师',
    name: '刘梦亚',
    line1: '12年教学经验',
    line2: '北京知名讲师',
  },
  {
    figureImg: figureImg2,
    title: '人文导师',
    name: '杨思思',
    line1: '16年教学经验',
    line2: '中国人民大学硕士',
  },
  {
    figureImg: figureImg3,
    title: '演说导师',
    name: '史心语',
    line1: '10年教学经验',
    line2: '北京大学英语翻译专业硕士',
  },
  {
    figureImg: figureImg4,
    title: '科学导师',
    name: '杨瑛',
    line1: '18年教学经验',
    line2: '原北京重点中学讲师',
  },
  {
    figureImg: figureImg5,
    title: '实验导师',
    name: '祝鑫',
    line1: '24年教学经验',
    line2: '高考把关教师',
  },
];

export default function Screen5() {
  const screen5Ref = useScreenSlideIn({
    scrollContainerSelector: SCROLL_CONTAINER,
    animationClassName: styles['screen5-anim'],
    triggerSlideRatio: 0.6,
  });

  return (
    <section
      ref={screen5Ref.ref as React.RefObject<HTMLElement>}
      className={styles['screen5-cover']}
    >
      <div className={styles['screen-top-content']}>
        <div className={styles['screen-top-title']}>专业的大师级保障</div>
        <div className={styles['screen-top-desc']}>
          沉淀顶尖行业专家方法论，与专业大师协同发力，共同打造领域新标杆
        </div>
      </div>
      <div className={styles['screen5-container']}>
        {SCREEN5_CARDS.map((card, i) => (
          <div key={i} className={`${styles['screen5-card']} }`}>
            <img className={styles['screen5-card-bg']} src={figureBgImg} alt="" loading="lazy" />
            <div
              className={styles['screen5-card-figure']}
              style={{ backgroundImage: `url(${card.figureImg})` }}
              aria-hidden
            >
              <div className={styles['screen5-card-bar']}>
                <div
                  className={styles['screen5-card-bar-bg']}
                  style={{ backgroundImage: `url(${figureTxtBg})` }}
                  aria-hidden
                />
                <div className={styles['screen5-card-bar-inner']}>
                  <span className={styles['screen5-card-bar-text']}>
                    {card.title} / {card.name}
                  </span>
                  <div className={styles['screen5-card-bar-extra']}>
                    <div className={styles['screen5-card-bar-desc']}>
                      <span className={styles['screen5-card-bar-dot']} />
                      <span className={styles['screen5-card-bar-desc-text']}>{card.line1}</span>
                    </div>
                    <div className={styles['screen5-card-bar-desc']}>
                      <span className={styles['screen5-card-bar-dot']} />
                      <span className={styles['screen5-card-bar-desc-text']}>{card.line2}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
